import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '_helpers';
import { alertActions } from './alert.slice';

const name = 'dataCollector';
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports
export const dataCollectorActions = { ...slice.actions, ...extraActions };
export const dataCollectorReducer = slice.reducer;

// implementation
function createInitialState() {
    return {
        data: null,
        isLoading: false,
        error: null,
    };
}

function createReducers() {
    return {
        clearData
    };

    function clearData(state){
        state.data = null;
    }
}

function createExtraActions() {
    const baseUrl = process.env.REACT_APP_API_URL;

    return {
        getData: getData()
    };

    function getData() {
        return createAsyncThunk(
            `${name}/getData`,
            async function (vin, { dispatch }) {
                //await fetchWrapper.get(`${baseUrl}/data_collector?vin=${vin}`)
                try {
                    const data = await fetchWrapper.get(`${baseUrl}/data_collector?vin=${vin}`)
                    dispatch(alertActions.success({message: 'Actualisation des données data collector', showAfterRedirect: true}))
                    return data;
                }catch (error) {
                    const message = error ?? "Erreur lors de l'acualisation des données data collector";
                    dispatch(alertActions.error({message: message, showAfterRedirect: true}));
                }            
            }
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        getData();

        function getData() {
            const { pending, fulfilled, rejected } = extraActions.getData;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.data = action.payload;
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.error.message || 'Echec de récupération des données';
                });
        }
    };
}

export default dataCollectorReducer;
